/* eslint-disable */
import styled, { css } from 'styled-components';
import cssKit from '../../css';

export const StyledModalHeading = styled.div`

`;

export const StyledModalCloseButton = styled.button`
  color: black;
  position: absolute;
  font-size: 14px;
  top: 10px;
  left: 10px;
  margin: 0 0 1.875rem;
`;

/* eslint-enable */



/** WEBPACK FOOTER **
 ** ./src/components/Modal/styles.js
 **/